<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="10">
        <h1 class="page-title">Assignment</h1>
        <button nz-button nzType="primary" class="right_margin new-btn ml-1" (click)="expandAll()"
            *ngIf="lst_Assignment.length"> <span nz-icon [nzType]=" isExpandAll ? 'right-circle' : 'down-circle'"
                nzTheme="outline"></span> {{isExpandAll ? 'Expand' : 'Collapse'}} All</button>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="18" nzLg="16" nzXl="14" class="btnsearch">
        <div class="header-right-box">
            <button nz-button nzType="primary" class="right_margin new-btn" (click)="showAddUpdateAssignment()"><i
                    nz-icon nzType="plus"></i> New</button>
            <input type="text" class="right_margin search-input" nz-input
                placeholder="Search here by type at least 3 character ..." [(ngModel)]="searchText"
                (keyup)="onSearch($event)" />
            <i nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                nzTooltipTitle="You need to wait for 3 seconds after search apply"></i>
        </div>
    </div>
</div>
<div class="table-height" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header" #sortTable [nzData]="lst_Assignment" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' :lst_Assignment.length > 0 ||  isAssignmentListLoaded}">
        <thead>
            <tr class="tableheader">
                <th nzWidth="180px" [nzAlign]="'left'" (nzSortOrderChange)="sort('invoice')" [nzSortFn]="true">QB
                    Invoice#
                </th>
                <th nzWidth="200px" [nzAlign]="'left'" (nzSortOrderChange)="sort('name')" [nzSortFn]="true">QB Customer
                    Name
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" (nzSortOrderChange)="sort('createdby')" [nzSortFn]="true">Created
                    By
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" (nzSortOrderChange)="sort('createddate')" [nzSortFn]="true">
                    Created Date
                </th>
                <th nzWidth="340px" [nzAlign]="'left'">Notes</th>
                <th nzWidth="90px" [nzAlign]="'center'">Action</th>
            </tr>
        </thead>
        <tbody [ngClass]="{'has-data' : lst_Assignment.length > 0}">
            <ng-container *ngFor="let data of lst_Assignment;let i = index;let even=even;">
                <tr [ngClass]="{'expanded'  : data.expand,'is-even-row' : even}" class="pointer"
                    (click)="onExpandChange(i,!data.expand,data,data.id)">
                    <td [nzAlign]="'left'" [(nzExpand)]="data.expand"
                        (nzExpandChange)="onExpandChange(i,!data.expand,data,data.id)">
                        <span><a [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+data.transactionID"
                                target="_blank"> {{ data.invoiceNo }} </a> </span>
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis>{{ data.customerName }}</td>
                    <td [nzAlign]="'left'"> {{ data.createdBy }}</td>
                    <td [nzAlign]="'left'">{{ data.createdOn.slice(0,-1) | date : 'MM/dd/yyyy' }}</td>
                    <td [nzAlign]="'left'" class="note-column">
                        {{data.note ? data.note : '-'}}</td>
                    <td [nzAlign]="'right'">
                        <a class="mr-1" [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}"
                            (click)="$event.stopPropagation(); editAssignment(data)" nz-tooltip
                            nzTooltipTitle="Edit Assignment"><img src="../assets/images/edit.svg">
                        </a>
                        <a class="right_margin" (click)="$event.stopPropagation()" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete assignment?"
                            (nzOnConfirm)="deleteAssignment(data,i)" [nzIcon]="iconTpl" nz-tooltip
                            nzTooltipTitle="Delete Assignment" nzOkText="Yes" nzCancelText="No">
                            <img src="../assets/images/Delete.svg">
                        </a>
                        <a class="mr-1" (click)="$event.stopPropagation();showHistoryModal(data)" nz-tooltip
                            nzTooltipTitle="View Audit Log(s)"><img src="../assets/images/Audit-Icon.png"> </a>
                        <ng-template #iconTpl>
                            <i nz-icon nzType="question-circle-o" style="color: red;"></i>
                        </ng-template>
                    </td>
                </tr>
                <tr [nzExpand]="data.expand">
                    <nz-table class=" mt-1" nzTableLayout="fixed" #basicTable [nzData]="data.stocks"
                        [nzShowPagination]="false" [nzScroll]="{ y: 'calc(100vh - 30em)' }" [nzPageSize]="10"
                        [nzTotal]="data.stocks?.length" [nzFrontPagination]="false"
                        [ngClass]="{'table-loading' :lst_Assignment.length > 0 ||  isAssignmentPartsLoaded, 'child-table' : !isAssignmentPartsLoaded}">
                        <thead>
                            <tr>
                                <th nzWidth="50px" [nzAlign]="'center'">#</th>
                                <th nzWidth="15%" [nzAlign]="'left'">Stock</th>
                                <th [nzAlign]="'left'" [nzSortFn]="true"
                                    (nzSortOrderChange)="sortPart(!isAscPart,data.stocks)">Part</th>
                                <th nzWidth="100px" [nzAlign]="'right'">Action</th>
                            </tr>
                        </thead>
        <tbody >
            <ng-container>
                <tr *ngFor="let   p of basicTable.data;let pi = index;" [ngClass]="{'is-even-row' : even}">
                    <td [nzAlign]="'center'"></td>
                    <td [nzAlign]="'left'">{{p.stockName }}</td>
                    <td [nzAlign]="'left'">
                        <!-- <ng-container *ngFor="let i of p.partNumbers;let n = index;"> -->
                        {{ p.partNumber }} ({{p.assignedQuantity}})
                        <!-- <span *ngIf="n != p.partNumbers.length - 1"> | </span>
                    </ng-container> -->
                    </td>
                    <td [nzAlign]="'right'">
                        <a [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}" nz-popconfirm
                            nzPopconfirmTitle="Are you sure want to remove stock?"
                            (nzOnConfirm)="removePartNumber(p,data,i,pi)" [nzIcon]="iconTpl"
                            [nzPopconfirmTrigger]=" (data.qB_BL_Status | lowercase) == 'shipped' ? null : 'click'"><img
                                [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}"
                                class="mr-1 close-icon" src="./assets/images/Close.svg" nzOkText="Yes" nzCancelText="No"></a>
                        <ng-template #iconTpl>
                            <i nz-icon nzType="question-circle-o" style="color: red;"></i>
                        </ng-template>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <ng-container *ngIf="isAssignmentPartsLoaded">
            <tbody>
                <tr *ngFor="let i of [].constructor(6)">
                    <ng-container *ngFor="let i of [].constructor(6)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </nz-table>
    </tr>
    </ng-container>
    </tbody>
    <ng-container *ngIf="isAssignmentListLoaded">
        <tbody>
            <tr *ngFor="let i of [].constructor(100)">
                <ng-container *ngFor="let i of [].constructor(6)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
    </nz-table>
</div>
<app-add-update-assignment *ngIf="isVisible" [editAssignmentDetail]="editAssignmentDetail"
    (hideModal)="hideModal($event)">
</app-add-update-assignment>

<app-audit-history *ngIf="isAuditVisible" [entityType]="entityType" [entityDetails]="entityDetails"
    (hideModal)="hideAuditModal($event)"></app-audit-history>